<template>
  <div>
    <template v-if="back || (!referDoctor && !referLabTech && !referPhysio && !referNurse && !referCovid && !referHemo && !referIV && !referRadiology && !vaccinPop && !caregiver)">
      <div class="sa-mob-cont">
        <button class="sa-btn-back" @click="$router.push('/appointments/doctor-details/add-diagnosis/'+$route.params.appid)">
        <i class="icon-arrow-left"></i>
        </button>
        <h6 class="sa-dark-gray-text sa-mb20">Refer to</h6>
      <ul class="sa-refer-list">
        <li class="sa-sprite sa-doc-icon" @click="refDoctor"><strong>Doctor</strong>
        <small v-if="doctor && doctor.dept_name && !doctor.name">Referred Department - {{doctor.dept_name}} ({{doctor.st_nm}})</small>
        <small v-if="doctor && doctor.name">Referred Doctor - {{doctor.title}} {{doctor.name}}</small>
        <a v-if="doctor && doctor.st_nm" @click="removeReferral('doctor')" href="javascript:void(0);" class="sa-remove">Remove</a><small v-if="!(doctor && doctor.st_nm)">Please select Doctor</small></li>
        <li class="sa-sprite sa-test-pack" @click="refLabtech">
          <strong>Select Test and Package</strong>
          <small v-if="tests && tests.length">Medical tests Selected - {{Array.prototype.map.call(tests, function(item) { return item.name; } ).join(",") }}</small>
          <small v-if="packages && packages.length">Medical Packages Selected - {{Array.prototype.map.call(packages, function(item) { return item.name; } ).join(",") }}</small>
          <a v-if="(tests && tests.length) || (packages && packages.length)" @click="removeReferral('lab')" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-else>Please select Medical Tests and Packages</small>
        </li>
        <li class="sa-sprite sa-radiology" @click="refRadio">
          <span>Select Radiology
            <small v-if="radiologyData && radiologyData.length">Radiology Selected{{Array.prototype.map.call(radiologyData, function(item) { return item.name; }).join(",")}}</small>
          </span>
          <a @click="removeReferral('rad')" v-if="radiologyData && radiologyData.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(radiologyData && radiologyData.length)">Please select radiology</small>
        </li>
        <li class="sa-sprite sa-nurse" @click="refNurse">
          <strong>Nurse</strong>
          <small v-if="nurse && nurse.length">Referral Tasks - 
            <small>{{Array.prototype.map.call(nurse, function(item) { return item.name; }).join(",")}}</small>
          </small>
          <a @click="removeReferral('nurse')" v-if="nurse && nurse.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(nurse && nurse.length)">Please select Tasks</small>
        </li>
        <li class="sa-sprite sa-nurse" @click="refPhysio">
          <strong>Physiotherapist</strong>
          <small v-if="physio && physio.length">Referred treatment - {{Array.prototype.map.call(physio, function(item) { return item.name; }).join(",")}}</small>
          <a v-if="physio && physio.length" @click="removeReferral('physio')" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(physio && physio.length)">Please select Treatments</small>
        </li>
        <li class="sa-sprite sa-covid" @click="refCovid">
          <strong>Covid - 19</strong>
          <small v-if="covidData && covidData.length">Covid Selected{{Array.prototype.map.call(covidData, function(item) { return item.name; }).join(",")}}</small>
          <a @click="removeReferral('covi')" v-if="covidData && covidData.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(covidData && covidData.length)">Please select covid test</small>
        </li>
        <li class="sa-sprite sa-hemo" @click="refHemo">
          <strong>Hemodialysis</strong>
          <small v-if="hemodialysisData && hemodialysisData.length">Hemodialysis Selected{{Array.prototype.map.call(hemodialysisData, function(item) { return item.name; }).join(",")}}</small>
          <a @click="removeReferral('hem')" v-if="hemodialysisData && hemodialysisData.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(hemodialysisData && hemodialysisData.length)">Please select Hemodialysis test</small>
        </li>
        <li class="sa-sprite sa-IV" @click="refIV">
          <strong>IV</strong>
          <small v-if="vitamin_iv_dripData && vitamin_iv_dripData.length">Vitamin IV Drip Selected{{Array.prototype.map.call(vitamin_iv_dripData, function(item) { return item.name; }).join(",")}}</small>
          <a @click="removeReferral('iv')" v-if="vitamin_iv_dripData && vitamin_iv_dripData.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(vitamin_iv_dripData && vitamin_iv_dripData.length)">Please select Vitamin IV Drip </small>
        </li>
        <li class="sa-sprite sa-vaccin" @click="vaccin">
          <strong>Vaccination</strong>
          <small v-if="vaccination && vaccination.length">Vaccination Selected{{Array.prototype.map.call(vaccination, function(item) { return item.name; }).join(",")}}</small>
          <a @click="removeReferral('vacc')" v-if="vaccination && vaccination.length" href="javascript:void(0);" class="sa-remove">Remove</a>
          <small v-if="!(vaccination && vaccination.length)">Please select Vaccination</small>
        </li>
         <!-- <li class="sa-sprite sa-caregiver" @click="care">
          <strong>Caregiver</strong>
          <small >Reffered Task - Mother and Baby Care</small>
          <a class="sa-remove">Remove</a>
        </li> -->
      </ul>
	</div>
    </template>
    <refer-doctor :stid = "stid" :dept_id = "dept_id" :ref_doctorId = "ref_doctorId"  ref="doctorRef" :viewDoctor="viewDoctor" v-if="referDoctor" />
    <test-package :tst_id="tests" :pkg_id="packages" v-if="referLabTech"/>
    <select-radiology :rad="radiology" v-if="referRadiology" />
    <nurse :tsk_id="tsk_id" v-if="referNurse"/>
    <physiotherapist :trtmnt_id="trtmnt_id" v-if="referPhysio"/>
    <covid v-if="referCovid" :covid="covid"/>
    <refer-hemodialysis :hemo="hemodialysis" v-if="referHemo"/>
    <refer-iv :iv="vitamin_iv_drip" v-if="referIV"/>
    <vaccination :vaccin="vaccination" v-if="vaccinPop"/>
    <!-- <care-give v-if="caregiver"/> -->
  </div>
</template>
<script>
import ReferDoctorVue from './ReferDoctor.vue'
import Covid from "./Covid.vue"
import ReferHemodialysis from "./ReferHemodialysis.vue"
import ReferIV from "./ReferIV.vue"
import TestPackageVue from './TestPackage.vue'
import RadiologyVue from './Radiology.vue'
import NurseVue from './Nurse.vue'
import PhysiotherapistVue from './Physiotherapist.vue'
import { pro_url } from "../../../../../config/endpoints";
import VaccinationVue from './Vaccination.vue'
import CaregiveVue from "./Caregive.vue";
export default {
  mounted () {
    this.getReferralData()
  },
  components: {
    'refer-doctor': ReferDoctorVue,
    'test-package': TestPackageVue,
    'refer-hemodialysis':ReferHemodialysis,
    'refer-iv':ReferIV,
    'covid':Covid,
    'select-radiology': RadiologyVue,
    'nurse': NurseVue,
    'physiotherapist': PhysiotherapistVue,
    "vaccination": VaccinationVue,
    "care-give":CaregiveVue
  },
    data(){
        return{
            vaccinPop: false,
            doctorInfo: null,
            nurse: null,
            doctor: null,
            physio: null,
            tests: null,
            packages: null,
            covidData:null,
            covid:[],
            hemodialysisData:null,
            hemodialysis:[],
            vaccinationData:null,
            vaccination: [],
            vitamin_iv_drip:[],
            vitamin_iv_dripData:null,
            radiologyData:null,
            referPhysio: false,
            referNurse: false,
            referLabTech: false,
            referCovid: false,
            referIV: false,
            referHemo: false,
            caregiver:false,
            refertoFlag: false,
            referDoctor: false,
            referRadiology:false,
            trtmnt_id: [],
            tsk_id: [],
            tst_id: [],
            pkg_id: [],
            radiology:[],
            stid: '',
            dept_id: '',
            ref_doctorId: ''
        }
    },
    props: ['back', 'viewDoctor'],
    watch: {
      back: {
        immediate: false,
        deep: true,
        handler () {
          if (this.back) {
            this.referPhysio = false
            this.referNurse = false
            this.referLabTech = false
            this.referCovid = false
            this.referhemo = false
             this.caregiver = false
            this.referIV = false
            this.referDoctor = false
            this.vaccinPop = false
            this.referRadiology = false
          }
        }
      },
      viewDoctor: {
        immediate: false,
        deep: true,
        handler () {
          this.$parent.viewDoctor = this.viewDoctor
          this.$parent.doctorInfo = this.doctorInfo
        }
    }
    },
    methods: {
      removeReferral (refer) {        
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        let treatments = _self.patDetails.refPhysio
        let tests = _self.patDetails.refTests
        let tasks = _self.patDetails.refNurse
        let packages = _self.patDetails.refPackages
        let stid = _self.patDetails.stid
        let dept_id = _self.patDetails.dept_id
        let ref_doctorId = _self.patDetails.ref_doctorId
        let radiology = _self.patDetails.radiology
        let covid = _self.patDetails.covid
        let hemodialysis = _self.patDetails.hemodialysis
        let vitamin_iv_drip = _self.patDetails.vitamin_iv_drip
        let vaccination = _self.patDetails.vaccination
        if(refer == 'physio'){
          this.trtmnt_id = []
          treatments = []
        }
        if(refer == 'nurse'){
          tasks = []
        }
        if(refer == 'lab'){
          tests = []
          packages = []
        }
        if(refer == 'rad'){
          radiology=[],
          this.radiologyData = []
          _self.patDetails.radiology = []
          this.radiology = []
        }
        if(refer == 'doctor'){
          stid = ''
          dept_id = ''
          ref_doctorId = ''
        }
        if(refer == 'covi'){
          covid=[],
          this.covidData = []
          _self.patDetails.covid = []
          this.covid = []
        }
        if(refer == 'vacc'){
          vaccination=[],
          this.vaccinationData = []
          _self.patDetails.vaccination = []
          this.vaccination = []
        }
        if(refer === 'hem'){
          hemodialysis=[]
          _self.hemodialysisData=[]
          _self.patDetails.hemodialysis = []
          _self.hemodialysis = []
        }
        if(refer === 'iv'){
          vitamin_iv_drip = []
          _self.patDetails.vitamin_iv_drip = []
          _self.vitamin_iv_dripData = []
          _self.vitamin_iv_drip = []
        }
        let data = {
          "apnt_id": _self.patDetails.apnt_id,
           // "pid": _self.patDetails.pid,
            // "uid": _self.patDetails.refDoctor || "",
            ref_doctorId: ref_doctorId,
            stid: stid,
            dept_id: dept_id,
            "pkg_id": packages,
            "tsk_id": tasks,
            "tst_id": tests,
            "trtmnt_id": treatments,
            "radiology":radiology,
            "covid":covid,
            "hemodialysis": hemodialysis,
            "vitamin_iv_drip": vitamin_iv_drip,
            "vaccination":vaccination
        }
        console.log(data);
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:data
        }).then(response => {
            _self.loader = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Treatment referrals updated successfully",
                class: "sa-a-success"
            });
            _self.patDetails.refPhysio = _self.trtmnt_id
            _self.$localStorage.set('patDetails', JSON.stringify(_self.patDetails))
            _self.referPhysio = false            
            _self.referNurse = false    
            _self.referLabTech = false 
            _self.referCovid = false
            _self.referHemo = false     
            _self.referIV = false
             _self.caregiver = false  
            _self.referDoctor = false      
            _self.referRadiology = false
            _self.vaccinPop = false
            _self.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })
      },
      getReferralData () {
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
          uri: `${pro_url}/refer/getTreatmentReferal`,
          body:{
            "apnt_id": _self.patDetails.apnt_id
          }
        }).then(response => {
          if (response && response.status === 1000 && response.data) {
            console.log(response.data);
            _self.doctor = response.data.doctor
            if (_self.doctor) {
              _self.stid = _self.doctor.stid
              _self.dept_id = _self.doctor.dept_id
              _self.ref_doctorId = _self.doctor.id
              _self.patDetails.stid = _self.stid
              _self.patDetails.dept_id = _self.dept_id
              _self.patDetails.ref_doctorId = _self.ref_doctorId
            }
            if (response.data.treatment && response.data.treatment.name) {
              _self.physio = response.data.treatment.name
              _self.trtmnt_id = Array.prototype.map.call(_self.physio, p => p.id)
              _self.patDetails.refPhysio = _self.trtmnt_id
              }
            if (response.data.nurse && response.data.nurse.name) {
              _self.nurse = response.data.nurse.name
              _self.tsk_id = Array.prototype.map.call(_self.nurse, p => p.id)
              _self.patDetails.refNurse = _self.tsk_id
            }
            if (response.data.test_packages && response.data.test_packages.tests) {
              _self.tests = response.data.test_packages.tests.name
              _self.tst_id = Array.prototype.map.call(_self.tests, p => p.id)
              _self.patDetails.refTests = _self.tst_id
            }
            if (response.data.test_packages && response.data.test_packages.package) {
              _self.packages = response.data.test_packages.package.name
              _self.pkg_id = Array.prototype.map.call(_self.packages, p => p.id)
              _self.patDetails.refPackages = _self.pkg_id
            }
            if (response.data.radiology && response.data.radiology.count>0) {
              _self.radiologyData = response.data.radiology.name
              _self.radiology = Array.prototype.map.call(_self.radiologyData, p => p.id)
              _self.patDetails.radiology = _self.radiology
            }
            if (response.data.covid && response.data.covid.count>0) {
              _self.covidData = response.data.covid.name
              _self.covid = Array.prototype.map.call(_self.covidData, p => p.id)
              _self.patDetails.covid = _self.covid
            }
            if (response.data.hemodialysis && response.data.hemodialysis.count>0) {
              _self.hemodialysisData = response.data.hemodialysis.name
              _self.hemodialysis = Array.prototype.map.call(_self.hemodialysisData, p => p.id)
              _self.patDetails.hemodialysis = _self.hemodialysis
            }
              if (response.data.vaccination && response.data.vaccination.count>0) {
              _self.vaccinationData = response.data.vaccination.name
              _self.vaccination = Array.prototype.map.call(_self.vaccinationData, p => p.id)
              _self.patDetails.vaccination = _self.vaccination
            }
            if (response.data.vitamin_iv_drip && response.data.vitamin_iv_drip.count>0) {
              _self.vitamin_iv_dripData = response.data.vitamin_iv_drip.name
              _self.vitamin_iv_drip = Array.prototype.map.call(_self.vitamin_iv_dripData, p => p.id)
              _self.patDetails.vitamin_iv_drip = _self.vitamin_iv_drip
            }
            _self.$localStorage.set('patDetails', JSON.stringify(_self.patDetails))
          }
        })
      },
      refDoctor (){
        let _self = this
        _self.$emit('backEvent', false)
        if(!self.refertoFlag){
          _self.refertoFlag = true
          _self.referDoctor = true
        } else {
          _self.refertoFlag = false
          _self.referDoctor = false
        }
      },
      refLabtech () {
        this.referLabTech = true
        this.$emit('backEvent', false)
      },
       refCovid () {
        this.referCovid = true
        this.$emit('backEvent', false)
      },
       refHemo () {
        this.referHemo = true
        this.$emit('backEvent', false)
      },
       refIV () {
        this.referIV = true
        this.$emit('backEvent', false)
      },
      refNurse () {
        this.referNurse = true
        this.$emit('backEvent', false)
      },
      refPhysio () {
        this.referPhysio = true
        this.$emit('backEvent', false)
      },
       refRadio () {
        this.referRadiology = true
        this.$emit('backEvent', false)
      },
      vaccin(){
        this.vaccinPop = true
        this.$emit('backEvent', false)
      },
        care() {
        this.caregiver = true
        this.$emit('backEvent', false)
      },
    }
}
</script>
